<template>
 <div class="container objective mb-5">
    <div class="row">
      <div class="col-10 offset-1 text-center center">
        <h2>Our Objectives</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-10 offset-1 col-md-8 offset-md-2 offset-lg-0 col-lg-6 text-justify center">
        <ul>
          <li>
            <h3>Advance Living</h3>
            <p>
              To provide hoslitc support, assistance to, and promote advancement, for people living in low resource areas, both locally and abroad, addressing the Sustainable Development Goals as presented by the United Nations;
            </p>
          </li>
        </ul>
      </div>
      <div class="col-10 offset-1 col-md-8 offset-md-2 offset-lg-0 col-lg-6 text-justify center">
        <ul>
          <li>
            <h3>Advance Healthcare</h3>
            <p>
              To provide holistic support and assistance for all persons regarding global health, including those affected by natural or manmade disasters, including pandemics
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-10 offset-1 col-md-8 offset-md-2 offset-lg-0 col-lg-6 text-justify center">
        <ul>
          <li>
            <h3>Advance With no discrimination</h3>
            <p>
              To offer holistic support, including healthcare, to persons affected including family members and significant to persons without any form of discrimination;
            </p>
          </li>
        </ul>
      </div>
      <div class="col-10 offset-1 col-md-8 offset-md-2 offset-lg-0 col-lg-6 text-justify center">
        <ul>
          <li>
            <h3>Advance Quality of Living</h3>
            <p>
              To embark on education programmes to improve quality of life;
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-10 offset-1 col-md-8 offset-md-2 offset-lg-0 col-lg-6 text-justify center">
        <ul>
          <li>
            <h3>Advance Education</h3>
            <p>
              To hold awareness events, lectures, seminar, talks, conferences and any other activities both on a national and an international level.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .objective {
    h2 {
      padding-top: 2rem;
    }
    
    ul {
      list-style-image: url('@/assets/logo-flower.svg');
      list-style-position: outside;
      font-size: 3rem;

      b {
        font-size: 1.5rem;
      }

      p {
        font-size: 1rem;
      }
    }
  }
</style>